import React from "react";
import { BiCheck } from "react-icons/bi";
import "./service.css";
const Service = () => {
  return (
    <section id="service">
      <h5>What I Offer</h5>
      <h2>Services</h2>
      <div className="container services__container">
        <article className="service">
          {/* UI /UX */}
          <div className="service_head">
            <h3>Coding</h3>
          </div>
          <ul className="service_list">
            <li>
              <BiCheck className="service_list-icon" />
              <p>C</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>C++</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Python</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Php</p>
            </li>
          </ul>
        </article>
        {/* CONTENT CREATION */}
        <article className="service">
          <div className="service_head">
            <h3>WEB DEVELOPMENT</h3>
          </div>
          <ul className="service_list">
            <li>
              <BiCheck className="service_list-icon" />
              <p>Custom Website Development</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Website Maintenance</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>E-commerce Website Development</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Blog Customization or Management</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Web Development Services at Full Scale</p>
            </li>
          </ul>
        </article>
        {/* WEB DEVELOPMENT */}
        {/* <article className="service">
          <div className="service_head">
            <h3>CONTENT CREATION</h3>
          </div>
          <ul className="service_list">
            <li>
              <BiCheck className='service_list-icon' />
              <p>Blogs</p>
            </li>
            <li>
              <BiCheck className='service_list-icon' />
              <p>Video</p>
            </li>
            <li>
              <BiCheck className='service_list-icon' />
              <p>Podcasts</p>
            </li>
            <li>
              <BiCheck className='service_list-icon' />
              <p>Graphics</p>
            </li>
            <li>
              <BiCheck className='service_list-icon' />
              <p>Content Offers</p>
            </li>
          </ul>
        </article> */}
      </div>
    </section>
  );
};

export default Service;
